export default {
  'loanPaymentTemplate.title': 'Loan Payment Template',
  'loanPaymentTemplate.createConfirm.title': 'Create Loan Template',
  'loanPaymentTemplate.modify.title': 'Modify Loan Template',
  'loanPaymentTemplate.modifyRecurring.title': 'Modify Recurring Instructions',
  'loanPaymentTemplate.view.title': 'View Loan Template',
  'loanPaymentTemplate.deleteConfirm.title': 'Delete Loan Template',
  'loanPaymentTemplate.recurring.payment': 'Make this a Recurring Loan Payment',
  'loanPaymentTemplate.recurring.draw': 'Make this a Recurring Loan Draw',
  'loanPaymentTemplate.recurring.nextPayment': 'Next scheduled payment',
  'paymentTemplates.success.create': 'Template created',
  'paymentTemplates.success.modify': 'Template modified',
  'paymentTemplates.pendingPaymentsDeleted':
    'All pending payments associated with this template will be deleted.',
  'loanPaymentTemplate.accountOption.name':
    '<%= accountName %> - <%= accountNumber %> (<%= formattedBalance %>)',
  'loanPaymentTemplate.accountOption.shortName': '<%= accountName %> - <%= accountNumber %>',
  'loanPaymentTemplate.success.create': 'Success! A loan payment template has been created.',
  'loanPaymentTemplate.success.modify': 'Success! A loan payment template has been modified.',
  'loanPaymentTemplate.modifyWarning':
    'All previous payments associated with this instruction "<%- name %>" will be deleted.',
  'loanPaymentTemplate.paymentOptions.DEFAULT': 'Default Payment',
  'loanPaymentTemplate.paymentOptions.INTERESTONLY': 'Interest Only',
  'loanPaymentTemplate.paymentOptions.PRINCIPALONLY': 'Principal Only',
  'loanPaymentTemplate.paymentOptions.EXCESSTOINTEREST': 'Excess To Interest',
  'loanPaymentTemplate.paymentOptions.EXCESSTOPRINCIPAL': 'Excess To Principal',
  'loanPaymentTemplate.paymentOptions.ESCROWONLY': 'Escrow Only',
  'loanPaymentTemplate.paymentOptions.FEEONLY': 'Fee Only',
  'loanPaymentTemplate.recurring.delete.title': 'Delete Recurring Instruction',
  'loanPaymentTemplate.recurring.delete.message':
    'This instruction will be deleted and all pending payments will be deleted.',
  'loanPaymentTemplate.recurring.alert':
    'Clicking Initiate will send a payment outside of the recurring schedule.'
};
